<template>
    <div style="display: flex; flex-direction: column;">
        <div>
            <div style="padding: 20px; padding-left: 17px; width: 70px;">
                <div @click="() => { $GlobalStore.closeModalAll() }"><img :src="require('@/assets/img/member_talk_x.png')" style="width:18px;"></div>
            </div>
        </div>
        <div style="flex: 1;">
            <div v-if="isFromResult" style="display: flex; position: relative; height: 360px; align-items: center;">
                <div :class="[{ step1_init_delay1: !delayOneStart }, { step1_ani_delay1: delayOneStart }, { step2_ani_delay1: delayOneStart && delayTwoStart }, { step3_ani_delay1: delayOneStart && delayTwoStart && delayThreeStart }, { last_ani_delay1: lastDelay }]" style="position: absolute; top: 70px;">
                    <img :style="{ width: lastDelay ? '182px' : '188px' }" style="transition: width 6s;" :src="require('@/assets/img/delay_1.png')" alt="">
                </div>
                <div :class="[{ step1_init_delay2: !delayTwoStart }, { step1_ani_delay2: delayTwoStart }, { step2_ani_delay2: delayTwoStart && delayThreeStart }, { last_ani_delay2: lastDelay }]" style="position: absolute; ">
                    <img :style="{ width: lastDelay ? '136px' : '146px' }" style="transition: width 6s;" :src="require('@/assets/img/delay_2.png')" alt="">
                </div>
                <div :style="{ left: delayThreeStart ? '50%' : '100%', transform: delayThreeStart ? 'translateX(-37%)' : '' }" style="position: absolute; transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);">
                    <img style="width: 202px;" :src="require('@/assets/img/delay_3.png')" alt="">
                </div>
            </div>
            <div v-else style="height: 360px;">
                <div style="padding-top: 83px; text-align: center;">
                    <div style="font-size: 20px;font-weight: 700;line-height: 28px;">{{ transText }}</div>
                    <div style="display: flex; justify-content: center; gap: 8px; align-items: center; margin-top: 29px; margin-bottom: 22px;">
                        <div class="circle_progress_wrap">
                            <svg class="circle_progress" width="24" height="24" viewBox="0 0 24 24">
                                <circle class="frame" cx="12" cy="12" r="10" stroke-width="4" />
                                <circle :style="{ strokeDashoffset: getProgress + 'px' }" style="stroke-dasharray: 62.8318px;" class="bar" cx="12" cy="12" r="10" stroke-width="4" />
                            </svg>
                        </div>
                        <div style="font-size: 32px; font-weight: 700;">{{ delayPercent }}%</div>
                    </div>
                    <div v-if="positionType.lite">
                        <div v-if="step < 4">
                            <div v-for="each, index in 4" :key="index">
                                <object v-if="step === index" :data="require(`@/assets/img/delay_${index}.svg`)"></object>
                            </div>
                        </div>
                        <div v-else>
                            <div>
                                <object :data="require('@/assets/img/delay_4.svg')" type=""></object>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="step < 9">
                            <div v-for="each, index in 9" :key="index">
                                <object v-if="step === index" :data="require(`@/assets/img/delay_${index}.svg`)"></object>
                            </div>
                        </div>
                        <div v-else>
                            <div>
                                <object :data="require('@/assets/img/delay_9.svg')" type=""></object>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="text-align: center;">
                <div v-if="delayPercent < 100" style="font-weight: 700; font-size: 20px;">회원님의 포지션을 찾는 중입니다.</div>
                <div v-else style="font-weight: 700; font-size: 20px;">회원님의 축구 포지션을 찾았어요</div>
                <div v-if="delayPercent < 100" style="font-weight: 500;line-height: 24px; margin-top: 12px;">결과를 알려드리기 위해<br>선택한 내용들을 확인중입니다...</div>
                <div v-else style="font-weight: 500;line-height: 24px; margin-top: 12px;">회원님의 성향과 능력치를 분석하여<br>만족할만한 결과를 찾아봤습니다</div>
                <div style="margin-top: 20px; display: flex; align-items: center; justify-content: center; gap: 6px;">
                    <div style="width: 3px; height: 3px; border-radius: 50%; background-color: #210f03;"></div>
                    <div v-if="delayPercent < 100" style="font-size: 12px;font-weight: 500;line-height: 20px;">4분 이내에 내 포지션 찾기가 완료됩니다.</div>
                    <div v-else style="font-size: 12px;font-weight: 500;line-height: 20px;">실제 포지션과 조금의 차이가 있을 수 있습니다.</div>
                </div>
            </div>
        </div>
        <div style="margin-bottom: 90px;">
            <div style="display: flex; align-items: center; gap: 8px; justify-content: center; margin-bottom: 12px;">
                <div v-if="delayPercent < 100">
                    <img style="width: 21px;" :src="require('@/assets/img/chair.png')" alt="">
                </div>
                <div v-if="delayPercent < 100" style="font-size: 14px;font-weight: 500;line-height: 24px;">잠깐 사커하우에 앉아서 기다려주세요.</div>
                <div v-else style="font-size: 14px;font-weight: 500;line-height: 24px;">기다려주셔서 감사합니다.</div>
            </div>
            <div v-if="isFromResult" @click="showSoccerHow" class="common_btn">사커하우 둘러보기</div>
            <div v-else-if="!isFromResult && delayPercent < 100" class="common_btn" @click="() => { $GlobalStore.closeLastModal() }">확인 및 뒤로가기</div>
            <div v-else-if="!isFromResult && delayPercent >= 100" class="common_btn" @click="showMyPosition">내 포지션 확인하기</div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'PositionResultDelay',
    props: {
        isFromResult: {
            type: Boolean,
            default: false
        },
        position_type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            delayOneStart: false,
            delayTwoStart: false,
            delayThreeStart: false,
            lastDelay: false,
            step: 0,
            delayPercent: 0,
            interval: null,
            positionType: {},
            isApiCall: false,
            myPositionArr: []
        }
    },
    computed: {
        getProgress() {
            const RADIUS = 10
            const CIRCUMFERENCE = 2 * Math.PI * RADIUS
            const progress = this.delayPercent / 100
            const dashoffset = CIRCUMFERENCE * (1 - progress)

            return dashoffset
        },
        transText() {
            let result;
            if (this.delayPercent >= 0 && this.delayPercent < 20) {
                result = '선택하신 내용을 검토중입니다!';
            } else if (this.delayPercent >= 20 && this.delayPercent < 40) {
                result = '회원님의 능력치를 분석중입니다!';
            } else if (this.delayPercent >= 40 && this.delayPercent < 60) {
                result = '회원님의 성향을 파악중입니다!';
            } else if (this.delayPercent >= 60 && this.delayPercent < 80) {
                result = '어울리는 포지션을 탐색중입니다!';
            } else if (this.delayPercent >= 80 && this.delayPercent < 100) {
                result = '곧 결과를 학인할 수 있습니다!';
            } else {
                result = '회원님의 포지션을 찾았습니다!';
            }

            return result
        }
    },
    methods: {
        showMyPosition() {
            if (this.positionType.lite) {
                const myScores = JSON.parse(localStorage.getItem('scores'))
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.addModal('MyPosition', { savedScores: myScores })
                // localStorage.removeItem('POSITION_TYPE')
                // localStorage.removeItem('scores')
            } else {
                const positionArr = JSON.parse(localStorage.getItem('positionArr'))
                const groupedData = JSON.parse(localStorage.getItem('groupData'))
                // localStorage.removeItem('savePositionTimePro')
                // localStorage.removeItem('POSITION_TYPE')
                // localStorage.removeItem('positionArr')
                // localStorage.removeItem('groupData')
                this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: positionArr, groupedData: groupedData })
            }

        },
        showSoccerHow() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/home' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        async completeFindPosition() {
            if (this.isApiCall) {
                return
            }
            const res = await this.$Axios.post('/api/position/wait/complete')

            if (res.data.code === ResponseCode.SUCCESS) {
                this.isApiCall = true
            }
        },
        updateProgress() {
            const saveTime = this.positionType.lite ? localStorage.getItem('initPositionTime') : localStorage.getItem('savePositionTimePro');
            const transSaveTime = moment(saveTime, "YYYY-MM-DD HH:mm:ss");
            const now = moment();

            const stepDuration = this.positionType.lite ? 24 : 30;
            const elapsedSeconds = now.diff(transSaveTime, 'seconds');
            let step = Math.floor(elapsedSeconds / stepDuration);
            if (this.positionType.lite) {
                if (step >= 5) step = 5;
                this.step = step;
            } else {
                if (step >= 10) step = 10;
                this.step = step;
            }

            let percentage;
            if (this.positionType.lite) {
                percentage = (elapsedSeconds / 120) * 100; // 120초 = 2분
            } else {
                percentage = (elapsedSeconds / 180) * 100; // 180초 = 3분
            }

            if (percentage >= 100) {
                percentage = 100;
                clearInterval(this.interval);
                this.completeFindPosition();
                this.interval = null;
            }
            this.delayPercent = parseInt(percentage);
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
        this.interval = null
    },
    mounted() {
        this.interval = setInterval(this.updateProgress, 1000);
    },
    created() {
        const positionType = JSON.parse(localStorage.getItem('POSITION_TYPE'))

        // if (this.position_type === 'lite') {
        //     this.$GlobalStore.showAlert('포지션 찾기 lite 결과는 한 번만 확인이 가능합니다.')
        //     this.$GlobalStore.closeLastModal()
        // } else if(this.position_type === 'pro'){
        //     //포지션 선택 안됨.
        //     if(positionType){
        //         this.$GlobalStore.closeLastModal();
        //         const positionArr = JSON.parse(localStorage.getItem('positionArr'));
        //         const groupedData = JSON.parse(localStorage.getItem('groupData'));
        //         this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: positionArr, groupedData: groupedData });
        //
        //         // this.$GlobalStore.closeLastModal()
        //         // const ability_arr = this.$GlobalStore.loginInfo().position_pro_ability.split(',');
        //         // const myPosition = this.$GlobalStore.loginInfo().position
        //         // this.$set(this.myPositionArr, 'desc', myPosition)
        //         // this.$set(this.myPositionArr, 'position', myPosition)
        //         //
        //         // const groupData = {
        //         //     [FIND_POSITION_PRO_TITLE.HEALTH]: ability_arr[0],
        //         //     [FIND_POSITION_PRO_TITLE.EYESIGHT]: ability_arr[1],
        //         //     [FIND_POSITION_PRO_TITLE.MAIN_FORCE]: ability_arr[2],
        //         //     [FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT]: ability_arr[3],
        //         //     [FIND_POSITION_PRO_TITLE.BALL_CONTROL]: ability_arr[4],
        //         // };
        //         // this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: this.myPositionArr, showGraph: false, groupedData: groupData, isConfirmDirectClose: true })
        //     }else {
        //         this.$GlobalStore.closeLastModal()
        //         this.$GlobalStore.addModal('SelectFindPosition');
        //     }
        if (!positionType) {
            this.$GlobalStore.closeLastModal()
            this.$GlobalStore.addModal('SelectFindPosition');
        } else {
            this.positionType = positionType
            if (this.isFromResult) {
                setTimeout(() => {
                    this.delayOneStart = true
                }, 1000);

                setTimeout(() => {
                    this.delayTwoStart = true
                }, 2000);

                setTimeout(() => {
                    this.delayThreeStart = true
                }, 3000);

                setTimeout(() => {
                    this.lastDelay = true
                }, 3500);
            } else {
                this.updateProgress()
            }
        }

    }
}
</script>

<style scoped>
.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
}

.step1_init_delay1 {
    left: 100%;
    transform: translateX(-64%);
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.step1_ani_delay1 {
    left: 50%;
    transform: translateX(-70%);
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.step2_ani_delay1 {
    left: 50%;
    transform: translateX(-100%);
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.step3_ani_delay1 {
    left: 50%;
    transform: translateX(-103%);
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.last_ani_delay1 {
    left: 50%;
    transform: translateX(-108%);
    transition: all 6s ease-out;
}

.step1_init_delay2 {
    left: 0;
    transform: translateX(-100%);
    opacity: 0;
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.step1_ani_delay2 {
    left: 50%;
    transform: translateX(-10%);
    opacity: 1;
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.step2_ani_delay2 {
    left: 50%;
    transform: translateX(31%);
    opacity: 1;
    transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.last_ani_delay2 {
    left: 50%;
    transform: translateX(47%);
    opacity: 1;
    transition: all 6s;
}

.common_btn {
    width: 310px;
    height: 60px;
    border-radius: 30px;
    line-height: 60px;
    background-color: #210f03;
    color: #fff;
    margin: 0 auto;
    font-weight: 500;
    text-align: center;
}

.circle_progress_wrap {
    position: relative;
    width: 24px;
    height: 24px;
}

.circle_progress {
    transform: rotate(-90deg);
}

.frame,
.bar {
    fill: none;
}

.frame {
    stroke: #ebebeb;
}

.bar {
    stroke: var(--color-main);
    stroke-linecap: round;
}

.value {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: center;
    color: #888;
    font-size: 16px;
    line-height: 120px;
}
</style>